import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import { LocalStoreService } from './local-store.service';

import { environment } from '../../../environments/environment';

import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private apiUrl = environment.apiEndpoint + 'sessions';

  private currentUserSubject = new BehaviorSubject<any>(null);
  currentUser$ = this.currentUserSubject.asObservable(); // To read from other components

  constructor(
    private http: HttpClient,
    private localStoreService: LocalStoreService,
    private translateService: TranslateService
  ) {
    // To use it in app component so we can manage angularjs / angular views
    // Delete once the app is in angular

    // This is necessary if the user reload the page
    this.currentUserSubject.next(this.currentUser());
  }

  // Get default account company - TODO: willy -validate if the user has access to that company, otherwise select order by name
  getDefaultAccountCompany = () => {
    const accountCompanies = this.getAccountCompanies();

    return accountCompanies.find((company) => company.is_default || accountCompanies.length === 1);
  };

  // change this to Angular
  login(params): Observable<any> {
    return this.http.post(this.apiUrl, params);
  }

  logout(): Observable<any> {
    this.currentUserSubject.next(null);

    return this.http.delete(`${this.apiUrl}/0`, {});
  }

  // if validateSession === true it will check the session in the server
  // if not just check the user in the local
  isLoggedIn() {
    if (this.currentUser()) return true;

    return false;
  }

  currentUser() {
    const data = this.getCurrentUser();

    if (data && data.user_info) {
      return data.user_info;
    }

    return null;
  }

  getCurrentUser() {
    return JSON.parse(this.localStoreService.get('cu'));
  }

  setCurrentUser(key, val) {
    // TODO: We can re-adjust or object = user = { key: value }
    this.localStoreService.set(key, JSON.stringify(val));

    this.currentUserSubject.next(this.currentUser()); // val['user_info']
  }

  deleteCurrentUser() {
    this.localStoreService.unset('cu');
    this.localStoreService.unset('selectedAccountCompany');
    this.localStoreService.unset('timUserLang');
  }

  getAccountCompanies() {
    const data = JSON.parse(this.localStoreService.get('cu'));

    if (!data) return false;

    const accountCompanies = data.user_info.companies;
    // const accountCompanies = data['user_info'].companies;

    if (!accountCompanies) return false;

    return accountCompanies;
  }

  getSelectedAccountCompany() {
    if (this.localStoreService.get('selectedAccountCompany')) {
      return JSON.parse(this.localStoreService.get('selectedAccountCompany'));
    }

    // TODO: willy - what about if the user does not have permissions to access the default account??
    let company = this.getDefaultAccountCompany();

    this.setSelectedAccountCompany(company);

    return this.setCompanyObject(company);
  }

  setSelectedAccountCompany(company) {
    company = this.setCompanyObject(company);

    this.localStoreService.set('selectedAccountCompany', JSON.stringify(company));
  }

  getSelectedAccountCompanyWebsite() {
    return (
      this.localStoreService.get('selectedAccountCompanyWebsite') ||
      this.getDefaultAccountCompanyWebsite()
    );
  }

  getUserLanguage() {
    return JSON.parse(this.localStoreService.get('timUserLang')) || {};
  }

  setUserLanguage(language) {
    this.setCurrentTranslationLanguage(language.code);

    this.localStoreService.set('timUserLang', JSON.stringify(language));
  }

  setCurrentTranslationLanguage(code: string) {
    this.translateService.use(code);

    moment.locale(code);
  }

  hideWarningMessage(component, setting) {
    this.localStoreService.set(component, JSON.stringify(setting));
  }

  isWarningMessageHidden(component) {
    return JSON.parse(this.localStoreService.get(component)); // parse = get, stringify = set
  }

  // Get default account company website
  private getDefaultAccountCompanyWebsite() {
    const accountCompanyWebsites = this.getSelectedAccountCompany()['websites']; // .websites

    return accountCompanyWebsites.find(
      (website) => website.is_default || accountCompanyWebsites.length === 1
    );
  }

  // Store only these fields to localStorage
  private setCompanyObject(company) {
    if (!company) return false;

    // To avoid possibly not set or overflowed because it was too large
    let item = {
      id: company.id,
      commercial_name: company.commercial_name,
      logo: company.logo,
      is_default: company.is_default,
      account_id: company.account_id,
      currency_id: company.currency_id,
      country: {
        code: company.country.code,
        enable_states: company.country.enable_states,
        name: company.country.name,
        phone_code: company.country.phone_code,
      },
      websites: company.websites,
      time_zone: company.websites,
      atv_cr_enabled: null,
    };

    if (company.company_integration) {
      item.atv_cr_enabled = company.company_integration.atv_cr_enabled;
    }

    return item;
  }
}

// private currentUserSubject: BehaviorSubject<any>;
// this.currentUserSubject = new BehaviorSubject<any>(this.currentUser());

// getCurrentUserSubjectValue(): Observable<any> {
//   return this.currentUser$.asObservable();
// }

// private currentUserLangSubject$ = new BehaviorSubject<any>(null); // Not needed

// Not needed
// getCurrentUserLangSubjectValue(): Observable<any> {
//   return this.currentUserLangSubject$.asObservable();
// }

// this.currentUserLangSubject$.next(code); // Not needed
